/* Friking — carrusel de subcategorías de colección (flechas + chip activo visible) */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-fk-chips]').forEach(function (box) {
      if (box.getAttribute('data-ready')) return;
      box.setAttribute('data-ready', '1');
      var list = box.querySelector('.fk-chips__list'), prev = box.querySelector('.fk-chips__arrow--prev'), next = box.querySelector('.fk-chips__arrow--next');
      function upd() {
        prev.hidden = list.scrollLeft < 8;
        next.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 8;
      }
      prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.7, behavior: 'smooth' }); });
      next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.7, behavior: 'smooth' }); });
      list.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      var a = list.querySelector('.is-active');
      if (a) list.scrollLeft = Math.max(0, a.offsetLeft - 40);
      upd();
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
